import { render, staticRenderFns } from "./MongoFiles.vue?vue&type=template&id=06249fac&scoped=true&"
import script from "./MongoFiles.vue?vue&type=script&lang=js&"
export * from "./MongoFiles.vue?vue&type=script&lang=js&"
import style0 from "./MongoFiles.vue?vue&type=style&index=0&id=06249fac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06249fac",
  null
  
)

export default component.exports